// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__Qcicp","clinicsSelect":"TableHeading_clinicsSelect__3928f"};